<template>
  <transition name="fade">
    <div v-if="shouldDisplayPanel" class="panel">
      <span class="panel__exit">
        <i class="fa fa-times" @click.prevent="hidePanel"></i>
      </span>
      <transition mode="out-in" name="fade">
        <component
          :is="componentName"
          :feedback="currentRating.feedback"
          :ratings="ratings"
          :selected-rating="selectedRating"
          @selectRating="selectRating"
          @sendFeedback="sendFeedback"
        />
      </transition>
    </div>
  </transition>
</template>

<script>
// Components
import Confirmation from './Confirmation'
import Rating from './Rating'

// Config
import config from '@/config/rating'

export default {
  name: 'FeedbackPanel',
  components: {
    Confirmation,
    Rating
  },
  props: {
    lastMessageId: { type: String, required: true },
    shouldDisplayPanel: { type: Boolean }
  },
  data() {
    return {
      currentRating: {
        messageId: this.lastMessageId,
        value: null,
        feedback: null
      },
      feedback: null,
      isRatingOver: false,
      ratings: config.RATINGS_LIST,
      selectedRating: null
    }
  },
  computed: {
    componentName() {
      return this.isRatingOver ? 'Confirmation' : 'Rating'
    }
  },
  watch: {
    lastMessageId: function(newValue) {
      this.resetRating()
    },
    shouldDisplayPanel: function(newValue) {
      if (!newValue) {
        this.resetRating()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById('chatList').scrollTop = document.getElementById('chatList').scrollHeight
    })
  },
  methods: {
    hidePanel() {
      this.$emit('hidePanel')
      this.resetRating()
    },
    resetRating() {
      this.selectedRating = null
      this.currentRating = {
        messageId: this.lastMessageId,
        value: null,
        feedback: null
      }
      this.isRatingOver = false
    },
    selectRating(rating) {
      this.selectedRating = rating
      this.currentRating.value = rating.value
      this.$store.dispatch('socket_userRating', this.currentRating)
    },
    sendFeedback(feedback) {
      this.isRatingOver = true

      // Automatically hide panel after a few seconds
      setTimeout(() => {
        this.hidePanel()
      }, config.HIDE_PANEL_DELAY)

      // If no feedback no need to update rating
      if (!feedback.length) {
        return
      }

      this.currentRating.feedback = feedback
      this.$store.dispatch('socket_userRating', this.currentRating)
    }
  }
}
</script>

<style lang="css">
.panel {
  position: relative;
  padding: 15px;
  margin: 10px;
  border-radius: 5px;
  min-width: 250px;
  text-align: center;
  background: #f7f9fc;
}

.panel .fa-times {
  color: #8998af;
}
.panel__exit {
  position: absolute;
  right: 10px;
  top: 5px;
}
.panel__exit a {
  text-decoration: none;
  color: black;
  font-size: 14px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
